import React from 'react';

import Box from '@mui/material/Box';

import Alert from '../../common/Alert.jsx';
import MonthSelector from '../../MonthSelector.jsx';
import YearSelector from '../../YearSelector.jsx';
import useProdMgrsRepOptions from '../hooks/useProdMgrsRepOptions.js';
import ProdMgrsRepSelector from './ProdMgrsRepSelector.jsx';

export default function ProdMgrsSelectors({
  selectedYear,
  onYearChange,
  selectedMonth,
  onMonthChange,
  selectedRep,
  onRepChange,
}) {
  const { options, loading, error } = useProdMgrsRepOptions(selectedYear);

  // If current selectedRep is no longer valid, clear it
  React.useEffect(() => {
    if (!selectedRep) {
      return;
    }
    if (options.length > 0 && !options.includes(selectedRep)) {
      onRepChange('');
    }
  }, [options, selectedRep, onRepChange]);

  return (
    <>
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
        <YearSelector selectedYear={selectedYear} onChange={onYearChange} />

        <ProdMgrsRepSelector
          selectedYear={selectedYear}
          selectedRep={selectedRep}
          onRepChange={onRepChange}
          loading={loading}
        />

        <MonthSelector selectedMonth={selectedMonth} onChange={onMonthChange} />
      </Box>

      <Alert message={error} setMessage={() => {}} level="error" variant="snackbar" />
    </>
  );
}
